import {h} from 'preact';
import Fieldset from "./Fieldset";
import {renderFileRow} from "../../helper";

export default function CameraButton(props){
	const hasFiles = Array.isArray(props.values[props.field]) && props.values[props.field].length;
	const fileList = hasFiles ? props.values[props.field].map((file, key) => renderFileRow(file, key, props.field, props.onDeleteFile)): null;
	// console.log(props.horizonatal)
	return (
		<Fieldset hasErrors={props.errors[props.field]} title={props.getLabelField(props.field)} horizontal={props.horizontal||false}>
			<div className="file-input">
				<div className="file-input__body">
					<button type='button' onClick={props.openModal} className="file-input__button button-primary button-primary_pdv_lg">
						<span>{hasFiles ? 'Добавить':'Выбрать'}</span>
					</button>
					<span className="file-input__file-name">
						<span className="file-input__text">{hasFiles ? `Файлов выбрано: ${hasFiles}`:'Файлы не выбраны'}</span>
					</span>
				</div>
			</div>
			{
				!!hasFiles &&
				<ul className="file-input__files-list">
					{
						fileList
					}
				</ul>
			}
		</Fieldset>
	)
}
